"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bot = void 0;
const Types_1 = require("../Types");
const Rules_1 = require("../Rules");
class Bot {
    playerIndex;
    difficulty;
    constructor(playerIndex, difficulty = Types_1.Difficulty.EASY) {
        this.playerIndex = playerIndex;
        this.difficulty = difficulty;
    }
    getAction(view) {
        if (view.playerIndex !== this.playerIndex || view.currentPlayerIndex !== this.playerIndex) {
            throw new Error("Bot can only act on its own turn and observation");
        }
        if (view.legalActions.length === 0)
            throw new Error("Bot has no legal action");
        if (view.phase === Types_1.Phase.BIDDING)
            return this.bid(view);
        if (view.phase === Types_1.Phase.DISCARD || view.phase === Types_1.Phase.PLAYING) {
            const trump = view.trump;
            if (!trump)
                throw new Error("Trump must be chosen before discarding or playing");
            const available = view.legalActions.filter((action) => action.type === Types_1.ActionType.DISCARD || action.type === Types_1.ActionType.PLAY_CARD);
            const cards = available.map(action => {
                const card = view.hand.find(card => card.id === action.cardId);
                if (!card)
                    throw new Error("Legal action refers to a card outside the bot's hand");
                return { action, card };
            }).sort((a, b) => (0, Rules_1.cardStrength)(a.card, trump) - (0, Rules_1.cardStrength)(b.card, trump) || a.card.id - b.card.id);
            if (view.phase === Types_1.Phase.PLAYING && view.currentTrick.length > 0) {
                const winner = (0, Rules_1.trickWinner)(view.currentTrick, trump);
                if ((0, Rules_1.teamOf)(winner) !== (0, Rules_1.teamOf)(this.playerIndex)) {
                    const winning = cards.find(({ card }) => (0, Rules_1.trickWinner)([...view.currentTrick, { playerIndex: this.playerIndex, card }], trump) === this.playerIndex);
                    if (winning)
                        return winning.action;
                }
            }
            else if (view.phase === Types_1.Phase.PLAYING) {
                const ace = cards.find(({ card }) => card.rank === Types_1.Rank.ACE && (0, Rules_1.effectiveSuit)(card, trump) !== trump);
                if (ace)
                    return ace.action;
            }
            return cards[0].action;
        }
        return view.legalActions[0];
    }
    bid(view) {
        const bids = view.legalActions.filter((action) => action.type === Types_1.ActionType.ORDER_UP || action.type === Types_1.ActionType.CALL_TRUMP);
        const scored = bids.filter(action => !action.alone).map(action => {
            const suit = action.type === Types_1.ActionType.CALL_TRUMP ? action.suit : view.upcard.suit;
            const hand = view.dealerIndex === this.playerIndex && view.biddingRound === 1
                ? [...view.hand, view.upcard] : view.hand;
            return { action, strength: this.handStrength(hand, suit), suit };
        }).sort((a, b) => b.strength - a.strength);
        const best = scored[0];
        const pass = view.legalActions.find(action => action.type === Types_1.ActionType.PASS);
        if (pass && best.strength < 20)
            return pass;
        const trumps = view.hand.filter(card => (0, Rules_1.effectiveSuit)(card, best.suit) === best.suit);
        const alone = trumps.length >= 4
            && trumps.some(card => card.rank === Types_1.Rank.JACK && card.suit === best.suit)
            && best.strength >= 36;
        return { ...best.action, alone };
    }
    handStrength(hand, trump) {
        return hand.reduce((sum, card) => {
            if ((0, Rules_1.effectiveSuit)(card, trump) === trump) {
                return sum + (card.rank === Types_1.Rank.JACK ? (card.suit === trump ? 12 : 10) : card.rank - 4);
            }
            return sum + (card.rank === Types_1.Rank.ACE ? 4 : 0);
        }, 0);
    }
}
exports.Bot = Bot;
